import React from 'react';
import { ArrowRight, TrendingUp, Target, Zap, Brain } from 'lucide-react';
import StatCard from './StatCard';
import '../styles/Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const stats = [
    { icon: TrendingUp, number: '16+', label: 'Years Experience' },
    { icon: Target, number: 'B2B & B2C', label: 'Global Clients' },
    { icon: Zap, number: 'ROI-First', label: 'Performance Framework' },
    { icon: Brain, number: 'AI-Powered', label: 'Growth Strategies' }
  ];

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <div className="hero-badge">
          <span className="badge-dot"></span>
          Available for Performance Marketing Consulting Engagements
        </div>
        
        <h1 className="hero-title">
          Performance Marketing Consultant & Growth Marketing Consultant
        </h1>
        
        <p className="hero-subtitle">
          Helping B2B & B2C Brands Scale Revenue Through<br/>
          <span className="gradient-text">Data, Paid Media & AI-Driven Strategies</span>
        </p>
        
        <p className="hero-description">
          I'm Sanjib Roy, an independent <strong>performance marketing consultant</strong> and <strong>growth marketing consultant</strong> based in Kolkata, India. With 16+ years of experience, I help businesses scale through precision tracking, paid media optimization, advanced attribution, and AI-driven workflows. I turn data into revenue, not vanity metrics.
        </p>
        
        <div className="hero-buttons">
          <button onClick={scrollToContact} className="btn-primary">
            Hire Me as Your Consultant
            <ArrowRight size={18} />
          </button>
          <button onClick={scrollToServices} className="btn-secondary">
            View Consulting Services
          </button>
        </div>
        
        <div className="hero-stats">
          {stats.map((stat, index) => (
            <StatCard 
              key={index} 
              icon={stat.icon} 
              number={stat.number} 
              label={stat.label} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
